import { FunctionComponent, ReactNode } from "react";

import { classNames } from "@/utils/classNames";

export interface TabItem {
	label: string;
	value: string;
}

interface TabsProps {
	tabs: TabItem[];
	activeTab: string;
	onTabChange: (value: string) => void;
	ariaLabel?: string;
}

export const Tabs: FunctionComponent<TabsProps> = ({
	tabs,
	activeTab,
	onTabChange,
	ariaLabel = "Tabs",
}) => {
	return (
		<div className="border-b border-gray-200">
			<nav aria-label={ariaLabel} className="flex gap-1 -mb-px">
				{tabs.map((tab) => {
					const isActive = activeTab === tab.value;

					return (
						<button
							key={tab.value}
							className={classNames(
								"px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap cursor-pointer",
								isActive
									? "border-brand-light text-brand-light"
									: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
							)}
							type="button"
							onClick={() => onTabChange(tab.value)}
						>
							{tab.label}
						</button>
					);
				})}
			</nav>
		</div>
	);
};

interface TabPanelProps {
	value: string;
	activeTab: string;
	children: ReactNode;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({ value, activeTab, children }) => {
	if (value !== activeTab) {
		return null;
	}

	return <div>{children}</div>;
};
